import { render, staticRenderFns } from "./CollaboratorsTableComp.vue?vue&type=template&id=319e5c30&scoped=true&"
import script from "./CollaboratorsTableComp.vue?vue&type=script&lang=js&"
export * from "./CollaboratorsTableComp.vue?vue&type=script&lang=js&"
import style0 from "./CollaboratorsTableComp.vue?vue&type=style&index=0&id=319e5c30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319e5c30",
  null
  
)

export default component.exports